import * as React from 'react';
import { useTranslation } from 'react-i18next';

function timeSince(date: Date, referenceDate: Date) {
  const timeDifference = referenceDate.getTime() - date.getTime();
  const seconds = Math.floor(timeDifference / 1000);

  let interval = Math.floor(seconds / 31536000);

  if (interval >= 1) {
    return { interval, unit: TimeUnits.YEAR };
  }
  interval = Math.floor(seconds / 2592000);
  if (interval >= 1) {
    return { interval, unit: TimeUnits.MONTH };
  }
  interval = Math.floor(seconds / 86400);
  if (interval >= 1) {
    return { interval, unit: TimeUnits.DAY };
  }
  interval = Math.floor(seconds / 3600);
  if (interval >= 1) {
    return { interval, unit: TimeUnits.HOUR };
  }
  interval = Math.floor(seconds / 60);
  if (interval >= 1) {
    return { interval, unit: TimeUnits.MINUTE };
  }
  return { interval: Math.floor(seconds), unit: TimeUnits.SECOND };
}

enum TimeUnits {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  SECOND = 'SECOND',
}

export const useTimeSince = () => {
  const { t } = useTranslation();
  const format = React.useCallback(
    (date: Date, referenceDate: Date = new Date()) => {
      const timeDifference = timeSince(date, referenceDate);

      if (timeDifference.unit === TimeUnits.SECOND) return t('FORMAT_TIME.UNITS.MINUTE', { interval: 1 });

      return t(`FORMAT_TIME.UNITS.${timeDifference.unit}`, { interval: timeDifference.interval });
    },
    [t],
  );

  return format;
};
